// RdYlBu diverging colour ramp (inverted: cold=blue → neutral=yellow → hot=red)
// 5 stops at t = 0, 0.25, 0.5, 0.75, 1.0
const redYellowBlueRampData = [
    [0x31, 0x36, 0x95], // 0.00 – deep blue  (#313695)
    [0x74, 0xad, 0xd1], // 0.25 – light blue (#74add1)
    [0xff, 0xff, 0xbf], // 0.50 – pale yellow (#ffffbf)
    [0xf4, 0x6d, 0x43], // 0.75 – orange     (#f46d43)
    [0xa5, 0x00, 0x26], // 1.00 – deep red   (#a50026)
];
/** Linearly interpolate between the 5 ramp stops. */
function getRGBColorForValue_redYellowBlueRamp(scaledValue) {
    const clamped = Math.max(0, Math.min(1, scaledValue));
    const segment = clamped * (redYellowBlueRampData.length - 1);
    const lo = Math.floor(segment);
    const hi = Math.min(lo + 1, redYellowBlueRampData.length - 1);
    const f = segment - lo;
    return [
        Math.round(redYellowBlueRampData[lo][0] + f * (redYellowBlueRampData[hi][0] - redYellowBlueRampData[lo][0])),
        Math.round(redYellowBlueRampData[lo][1] + f * (redYellowBlueRampData[hi][1] - redYellowBlueRampData[lo][1])),
        Math.round(redYellowBlueRampData[lo][2] + f * (redYellowBlueRampData[hi][2] - redYellowBlueRampData[lo][2])),
    ];
}
/** Linear black→white ramp. */
function getRGBColorForValue_greyscaleRamp(scaledValue) {
    const v = 255 - Math.round(Math.max(0, Math.min(1, scaledValue)) * 255);
    return [v, v, v];
}
const colorFunctionsMap = {
    "red-yellow-blue": getRGBColorForValue_redYellowBlueRamp,
    "greyscale": getRGBColorForValue_greyscaleRamp,
};
/**
 * Returns the color function for the passed name. A color function maps a scaled value in [0, 1] to an RGB color.
 * If the name is not found, a default color function (red-yellow-blue ramp) is returned.
 */
export function getColorFunction(name) {
    return colorFunctionsMap[name] ?? getRGBColorForValue_redYellowBlueRamp;
}
